import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { api, fmtDateTime, ROLE_LABELS } from "@/lib/api";
import { Input } from "@/components/ui/input";

const TONE = (a) => a.includes("approve") || a.includes("release") ? "bg-emerald-50 text-emerald-800 border-emerald-200" : a.includes("reject") || a.includes("red_alert") ? "bg-red-50 text-red-800 border-red-200" : a.includes("consent") ? "bg-green-50 text-green-800 border-green-200" : "bg-slate-50 text-slate-700 border-slate-200";

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit", { params: { action: q || undefined } }).then((r) => setLogs(r.data)); }, [q]);
  return (
    <div className="space-y-6" data-testid="audit-trail-viewer">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><p className="eyebrow">Compliance</p><h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900 mt-1">Audit trail</h1><p className="text-sm text-slate-600 mt-1">Immutable record of data entry, edits, consent changes, AI drafts, approvals and releases.</p></div>
        <Input data-testid="audit-filter-input" className="w-56" placeholder="Filter by action e.g. consent" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <div className="border-l-2 border-slate-200 pl-4 space-y-3" data-testid="admin-audit-log-table">
        {logs.length === 0 && <p className="text-sm text-slate-500">No audit events.</p>}
        {logs.map((l) => (
          <div key={l.id} className="clinical-card p-3 sm:p-4 flex flex-wrap items-center gap-3 relative" data-testid="audit-log-entry-row">
            <span className="absolute -left-[23px] top-5 w-3 h-3 rounded-full bg-teal-600 border-2 border-white" />
            <span className={`badge-pill font-mono ${TONE(l.action)}`}>{l.action}</span>
            <div className="flex-1 min-w-[200px] text-sm"><span className="font-semibold text-slate-900">{l.actor_name}</span> <span className="text-slate-500">({ROLE_LABELS[l.actor_role] || l.actor_role})</span> on <span className="font-mono text-xs text-slate-600">{l.entity_type}/{l.entity_id?.slice(-6)}</span>
              {l.details && Object.keys(l.details).length > 0 && <p className="text-xs text-slate-500 mt-0.5 font-mono truncate max-w-xl">{JSON.stringify(l.details)}</p>}</div>
            <span className="text-xs text-slate-400 flex items-center gap-1"><ScrollText className="w-3.5 h-3.5" /> {fmtDateTime(l.timestamp)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
